<template>
  <div>
    <div class="cursor-pointer" @click="onTriggerClick">
      <custom-icon :icon="innerValue || 'patch-question'" />
    </div>
    <select-icon-dialog
      v-if="showSelectIconDialog"
      :visible="true"
      :selected-icon="innerValue"
      @selected="onSelected"
      @close="onDialogClose"
    />
  </div>
</template>

<script>
import CustomIcon from './CustomIcon';
import SelectIconDialog from './SelectIconDialog';

export default {
  name: 'IconSelector',

  components: { CustomIcon, SelectIconDialog },

  props: {
    value: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      showSelectIconDialog: false,
      innerValue: null,
    };
  },

  methods: {
    toggleSelectIconDialog(show) {
      this.showSelectIconDialog = show;
    },

    onTriggerClick() {
      this.toggleSelectIconDialog(true);
    },

    onDialogClose() {
      this.toggleSelectIconDialog(false);
    },

    onSelected(icon) {
      this.innerValue = icon;
      this.toggleSelectIconDialog(false);
      this.$emit('input', icon);
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(next) {
        this.innerValue = next;
      },
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/IconSelector/index.vue